import { apiService } from './api';
import { socketService } from './socketService';

class DuplicateCardService
{
  /**
   * Retrieves specific data from a project based on its ProjectId
   */
  async GetFewDataFromProject(projectId: number): Promise<any>
  {
    try
    {
      const response = await apiService.get(`Project/GetFewDataFromProject?projectId=${projectId}`);
      return response;
    }
    catch (error)
    {
      console.error('Error in GetFewDataFromProject:', error);
      throw error;
    }
  }

  /**
   * Updates an existing conversation (project, task, card, etc.)
   */
  async UpdateProject(requestData: any): Promise<any>
  {
    try
    {
      // API payload is usually posted directly to updating the conversation
      const response = await apiService.post('conversation/updateconversation', { ...requestData, SocketConnectionId: socketService.connectionId });
      return response;
    }
    catch (error)
    {
      console.error('Error in UpdateProject:', error);
      throw error;
    }
  }

  /**
   * Saves a completely new card
   */
  async SaveNewCard(requestData: any): Promise<any>
  {
    try
    {
      const response = await apiService.post('conversation/', requestData);
      return response;
    }
    catch (error)
    {
      console.error('Error in SaveNewCard:', error);
      throw error;
    }
  }

  /**
   * Retrieves all groups for a project context
   */
  async GetGroups(projectId?: number): Promise<any>
  {
    try
    {
      // The old service had a getGroups (no params) and getGroupsByProject. We combine/keep them separated as needed.
      const url = projectId ? `group/GetGroupsByProject?projectId=${projectId}` : 'group/GetGroups';
      const response = await apiService.get(url);
      return response;
    }
    catch (error)
    {
      console.error('Error in GetGroups:', error);
      throw error;
    }
  }

  /**
   * Retrieves layers based on config value ID
   */
  async GetLayersByConfigValueId(projectId: number, configValueId: number): Promise<any>
  {
    try
    {
      const response = await apiService.get(
        `layer/GetLayersByConfigValueId?ProjectId=${projectId}&ConfigValueId=${configValueId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error in GetLayersByConfigValueId:', error);
      throw error;
    }
  }

  /**
   * Retrieves conversation layers related to a project ID
   */
  async GetConversationByProjectId(projectId: number): Promise<any>
  {
    try
    {
      const response = await apiService.post(
        `Conversation/GetConversationByProjectId?projectId=${projectId}`,
        {},
      );
      return response;
    }
    catch (error)
    {
      console.error('Error in GetConversationByProjectId:', error);
      throw error;
    }
  }

  /**
   * Updates multiple layers for a configuration
   */
  async UpdateLayers(requestData: any): Promise<any>
  {
    try
    {
      const response = await apiService.put('conversation/UpdateLayers', {
        ...requestData,
        SocketConnectionId: socketService.connectionId,
      });
      return response;
    }
    catch (error)
    {
      console.error('Error in UpdateLayers:', error);
      throw error;
    }
  }

  /**
   * Mark important status for a conversation (card/project)
   */
  async UpdateImportant(requestParams: any): Promise<any>
  {
    try
    {
      const response = await apiService.put('conversation/MarkImportant', {
        ...requestParams,
        SocketConnectionId: socketService.connectionId,
      });
      return response;
    }
    catch (error)
    {
      console.error('Error in UpdateImportant:', error);
      throw error;
    }
  }

  /**
   * Set multiple conversations as viewed
   */
  async SetConversationsAsViewed(conversationIdsString: string): Promise<any>
  {
    try
    {
      const response = await apiService.put(
        `alert/SetConversationsAsViewed?conversationIdsString=${conversationIdsString}`,
        {},
      );
      return response;
    }
    catch (error)
    {
      console.error('Error in SetConversationsAsViewed:', error);
      throw error;
    }
  }

  /**
   * Retrieves projects available for a given config value (card type)
   */
  async GetProjectsByConfigValueId(configValueId: number): Promise<any>
  {
    try
    {
      const response = await apiService.get(
        `project/getProjectsByConfigValueId?configValueId=${configValueId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error in GetProjectsByConfigValueId:', error);
      throw error;
    }
  }
}

export const duplicateCardService = new DuplicateCardService();
